import * as Sentry from "@sentry/react"
import { createRoot } from "react-dom/client"
import { toast } from "sonner"

import { App } from "@/App.tsx"
import { createApp } from "@/context.ts"
import { getLogger } from "@/lib/logging.ts"
import { isApple } from "@/lib/userAgent.ts"
import { initSentry } from "@/sentry.ts"
import { loadSquircle } from "@/squircle.ts"

import "./index.scss"

if (isApple) {
  document.body.classList.add("is-apple")
}

const log = getLogger("Main")

window.addEventListener("vite:preloadError", () => {
  toast.error("You're using an outdated version of the app. Please reload the page.", {
    duration: Infinity
  })
})

// Uncomment to test iframe error reporting
// To display Matter-in-Matter preview, set the URL of PreviewFrame to http://localhost:3000
// if (window.parent != window) {
//   console.log(notifyParent)
//   throw new Error("An error!")
// }

function render() {
  loadSquircle().catch((e) => log.error("Failed to load", e))

  const root = document.getElementById("root")

  if (root != null) {
    const { globalContext, router, routerResolved } = createApp()

    initSentry(router)

    createRoot(root, {
      onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        log.warn("Uncaught error", error, errorInfo.componentStack)
      }),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    }).render(
      <App globalContext={globalContext} router={router} routerResolved={routerResolved} />
    )
  }
}

render()